import { render, staticRenderFns } from "./calendartoday.vue?vue&type=template&id=41be206a"
import script from "./calendartoday.vue?vue&type=script&lang=js"
export * from "./calendartoday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports